import { Container } from '@mui/material';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../Components/Layout/Layout';
import Orders from '../Pages/Orders';
import OrderDetails from '../Pages/OrderDetails';
import OrderEdit from '../Pages/OrderEdit';
import PrivateRoute from './PrivateRoute';
import Login from '../Pages/Login';
import RestorePassword from '../Pages/RestorePassword';
import OrdersHistory from '../Pages/OrdersHistory';

export default function AppRoutes() {
	return (
		<Router>
			<Container>
				<Routes>
					<Route exact path='/' element={<PrivateRoute />}>
						<Route element={<Layout />}>
							<Route exact path='/' element={<Orders />} />
							<Route path=':orderId/view' element={<OrderDetails />} />
							<Route path=':orderId/edit' element={<OrderEdit />} />
							<Route path='/orders-history' element={<OrdersHistory />} />
						</Route>
					</Route>
					<Route path='/login' element={<Login />} />
					<Route path='/restore-password' element={<RestorePassword />} />

					<Route path='*' element={<>Not Found</>} />
				</Routes>
			</Container>
		</Router>
	);
}
